function comprueba(){
  if(check.checked){
    document.getElementById("subscribe").disabled = false;
    document.getElementsByClassName("footer__newsletter-input")[0].focus();
    //document.getElementsByClassName("footer__newsletter-input")[0].disabled = false;
  }
  else{
    document.getElementById("subscribe").disabled = true;
    //document.getElementsByClassName("footer__newsletter-input")[0].disabled = true;
  }
};    


$(document).ready(function() {
  var check_newsletter_footer = document.getElementById('check');
  var check_newsletter = document.getElementById('check_section');
  document.getElementById("subscribe").disabled = true;
  //document.getElementsByClassName("footer__newsletter-input")[0].disabled = true;
  if (!check_newsletter_footer) {
    return;
  } else {
    check.addEventListener("change", comprueba, false);
  }

});